export default __webpack_public_path__ + "static/media/black_friday_dashboard_slide.22a5bd9b.png";